// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__2FKjR","right":"styles_right__27594"};